import { FieldPath, FieldValues } from 'react-hook-form';

import { ExclusiveSelectionGroup } from '../ExclusiveSelectionGroup';

import { KeyLabel, Props } from './TripleChoiceButton.types';

const yesNoUnknownAnswers: KeyLabel[] = [
  { key: 'Yes', label: 'oui' },
  { key: 'No', label: 'non' },
  { key: 'Unknown', label: 'info inconnue' },
];

/**
 * @deprecated use `ExclusiveChipGroup` instead
 * @example import { ExclusiveChipGroup } from '@randstad-lean-mobile-factory/react-form-fields';
 *          import { ChipGroupItem } from '@randstad-lean-mobile-factory/react-components-core';
 *
 *          <ExclusiveChipGroup control={control} name="name">
 *            <ChipGroupItem value="Yes" disabled>oui</ChipGroupItem>
 *            <ChipGroupItem value="No">non</ChipGroupItem>
 *            <ChipGroupItem value="Unknown">info inconnue</ChipGroupItem>
 *          </ExclusiveChipGroup>
 */
export const TripleChoiceButton = <
  TFieldValues extends FieldValues,
  TName extends FieldPath<TFieldValues>,
>(
  props: Props<TFieldValues, TName>
) => (
  <ExclusiveSelectionGroup<TFieldValues, KeyLabel, string | undefined, TName>
    {...props}
    values={yesNoUnknownAnswers}
    getSelectedFormValue={element => element?.key}
    getSelectedValue={value => {
      return (
        yesNoUnknownAnswers.find(_ => _.key === value) ?? { key: 'Unknown', label: 'info inconnue' }
      );
    }}
    getStringValue={({ label }) => label}
    getKey={({ key }) => key}
  />
);
